import React from "react";

const NOTIFICATION_AGT_EXT_OP_DIALOGUE: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99999 9C4.99999 7.14348 5.73749 5.36301 7.05024 4.05025C8.363 2.7375 10.1435 2 12 2C13.8565 2 15.637 2.7375 16.9497 4.05025C18.2625 5.36301 19 7.14348 19 9V12.764L20.822 16.408C20.9059 16.5757 20.9455 16.7621 20.937 16.9494C20.9286 17.1368 20.8724 17.3188 20.7738 17.4783C20.6753 17.6379 20.5375 17.7695 20.3737 17.8608C20.2099 17.9521 20.0255 18 19.838 18H15.874C15.6516 18.8582 15.1504 19.6183 14.4493 20.1609C13.7481 20.7035 12.8866 20.9979 12 20.9979C11.1134 20.9979 10.2519 20.7035 9.55073 20.1609C8.84956 19.6183 8.34843 18.8582 8.12599 18H4.16199C3.97447 18 3.79005 17.9521 3.62626 17.8608C3.46246 17.7695 3.32473 17.6379 3.22614 17.4783C3.12754 17.3188 3.07137 17.1368 3.06294 16.9494C3.05451 16.7621 3.09412 16.5757 3.17799 16.408L4.99999 12.764V9ZM10.268 18C10.4435 18.304 10.696 18.5565 11 18.732C11.3041 18.9075 11.6489 18.9999 12 18.9999C12.351 18.9999 12.6959 18.9075 12.9999 18.732C13.304 18.5565 13.5564 18.304 13.732 18H10.268ZM12 4C10.6739 4 9.40214 4.52678 8.46446 5.46447C7.52678 6.40215 6.99999 7.67392 6.99999 9V12.764C6.99997 13.0743 6.92773 13.3804 6.78899 13.658L5.61899 16H18.382L17.212 13.658C17.0729 13.3805 17.0003 13.0744 17 12.764V9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5978 4.52678 13.3261 4 12 4Z"
        fill="#6C757D"
      />
      <circle cx="16.5" cy="5.5" r="2.5" fill="#DE2E1F" />
    </svg>
  );
};

export default NOTIFICATION_AGT_EXT_OP_DIALOGUE;
